module.exports = __webpack_public_path__ + "static/media/11x14.8552b15e.png";